import { PaymentSubscriptionsIcon } from 'foundations-assets/icons/components/PaymentSubscriptionsIcon';
import { InvoiceIcon } from 'foundations-assets/icons/components/InvoiceIcon';
import { Paths } from './Paths';
import { jsx as _jsx } from "react/jsx-runtime";
export const NavConfig = [{
  path: Paths.SUBSCRIPTIONS,
  messageKey: 'app.nav.routes.subscriptions',
  icon: /*#__PURE__*/_jsx(PaymentSubscriptionsIcon, {
    size: "400",
    color: "icon-core-default"
  })
}, {
  path: Paths.INVOICES,
  messageKey: 'app.nav.routes.invoices',
  icon: /*#__PURE__*/_jsx(InvoiceIcon, {
    size: "400",
    color: "icon-core-default"
  })
}];